<div class="flex flex-col h-full">
  @if (response) {
    @if (pageProperties.enableProgressBar) {
      <progress
        max="100"
        [value]="pageProperties.percentProgress"
        class="flex w-full h-3 progress-dynamic-theme flex-shrink-0"
        [attr.aria-label]="'survey.progress.label' | translate"
      ></progress>
    }
    <app-topbar class="flex-shrink-0"></app-topbar>
    <main
      id="survey-for-container"
      class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden background-image-dynamic-theme"
    >
      <div class="survey-background-overlay min-h-full">
        <div
          class="min-h-full text flex-col flex-1 md:grid lg:grid-cols-6 2xl:grid-cols-12 lg:max-w-[1920px] mx-auto lg:gap-4"
        >
          <app-survey-form
            [previewMode]="previewMode"
            (formReady)="onFormReady($event)"
            (submitEmitter)="submit($event)"
            (deactivateGuard)="deactivateGuard($event)"
            (previousEmitter)="toPreviousState()"
            [loading]="isLoading"
            [answers]="answers"
            [responseId]="response.responseId"
            [currentState]="response.stateId"
            [questions]="questions"
            [displayBackButton]="response.enableBackNavigation"
            [surveyTitle]="response.surveyTitle"
            (validationErrorCountEmitter)="updateValidationErrorCount()"
            (pagePropertiesEmitter)="updatePageProperties($event)"
            class="md:px-6"
          >
          </app-survey-form>
        </div>
      </div>
    </main>
    <app-navigation
      (previousClick)="toPreviousState()"
      [validationErrorCount]="
        previewMode === PreviewMode.FreeFlow ? 0 : validationErrorCount
      "
      [disableNext]="
        isNavigating || (form?.valid === false && previewMode !== PreviewMode.FreeFlow)
      "
      [disablePrevious]="isNavigating"
      [hasPreviousPage]="response.enableBackNavigation"
      [nextButtonText]="
        pageProperties.isLastPage
          ? 'navigation.submit.button'
          : 'navigation.next.button'
      "
      class="flex-shrink-0"
    ></app-navigation>
  }

  <app-confirmation-modal
    [isVisible]="showConfirmationModal"
    [title]="'editresponse.confirmation.title' | translate"
    [message]="'editresponse.confirmation.message' | translate"
    [confirmButtonText]="'editresponse.confirmation.save' | translate"
    [cancelButtonText]="'editresponse.confirmation.cancel' | translate"
    (confirm)="onConfirmEditChanges()"
    (cancel)="onCancelEditChanges()"
  ></app-confirmation-modal>
</div>
